import { HttpInterceptorFn } from '@angular/common/http'
import { inject } from '@angular/core'
import { catchError, switchMap, throwError } from 'rxjs'
import { AuthService } from './auth.service'
import { StorageService } from './storage.service'

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const storageService = inject(StorageService)
  const authService = inject(AuthService)

  const publicUrls = ['/i18n/', '/api/login', '/api/token/refresh']

  const isPublicUrl = publicUrls.some((url) => req.url.includes(url))

  if (isPublicUrl) {
    return next(req)
  }

  const token = storageService.getToken()

  if (!token) {
    return next(req)
  }

  if (storageService.isTokenExpired(token)) {
    return authService.refreshToken().pipe(
      switchMap((refreshed) => {
        if (!refreshed) {
          authService.logout()
          return throwError(() => new Error('Token expired'))
        }

        const newToken = storageService.getToken()
        if (newToken) {
          const authReq = req.clone({
            setHeaders: {
              Authorization: `Bearer ${newToken}`,
            },
          })
          return next(authReq)
        }

        return next(req)
      }),
      catchError((error) => {
        authService.logout()
        return throwError(() => error)
      }),
    )
  }

  const authReq = req.clone({
    setHeaders: {
      Authorization: `Bearer ${token}`,
    },
  })

  return next(authReq).pipe(
    catchError((error) => {
      if (error.status === 401) {
        return authService.refreshToken().pipe(
          switchMap((refreshed) => {
            if (refreshed) {
              const newToken = storageService.getToken()
              if (newToken) {
                const newAuthReq = req.clone({
                  setHeaders: {
                    Authorization: `Bearer ${newToken}`,
                  },
                })
                return next(newAuthReq)
              }
            }
            return throwError(() => error)
          }),
        )
      }
      return throwError(() => error)
    }),
  )
}
